import { Component, OnInit, Input } from "@angular/core";

@Component({
  selector: "unh-rating",
  templateUrl: "./rating.component.html",
  styleUrls: ["./rating.component.scss"],
})
export class RatingComponent implements OnInit {
  @Input() rating;

  constructor() {}

  ngOnInit(): void {}
}
